import React from "react";

function Loading() {
  return (
    <div className="container mt-5 mb-5">
      <div className="loading-text">Loading...</div>
    </div>
  );
}

export default Loading;
